import { auctionEdit, auctionFail } from "@/api/onlinetaking"; // 拍单请求
import { drugPaymentAdd3 } from "@/api/drugpayment"; // 划价单请求
import { pricingJudge } from "@/api/mutexdrugs"; // 十八反十九畏请求
import { ingredientsList } from "@/api/ingredients"; // 辅料请求
import { drugList } from "@/api/drug"; // 获取药品请求
import AddressManage from "@/components/PricingDetails/AddressManage/index.vue"; // 地址组件
import { getUniOrderNumber, getOrderNumber, editOrderStaging } from '@/api/pricingDetails'
import { takingDosageOptions } from '../../../../utils/const'

import { Utils } from '@/utils/utils'
export default {
    name: 'TakingEdit',
    components: { AddressManage },
    data() {
        return {
            orderNumber: '',//联合订单编号
            editForm: {}, // 划价对象
            doctorOptions: [], // 医生选项
            provinceList: [], // 省份列表
            cityList: [], // 城市列表
            regionList: [], // 区域列表
            scopeList: [], // 范围列表
            ingredientsList: [], // 辅料列表
            ingredientsId: null, // 当前选中辅料id
            drugId: null, // 当前选中药品id
            drugOptions: [], // 药品列表
            drugType: this.$drugType, // 药品类型
            failForm: { reason: null }, // 图片识别失败的表单
            selectLoading: false, //下拉框loading
            takingDosageOptions: takingDosageOptions
        }
    },
    props: {
        examine: Function,
        dialogVisible: Boolean,
        getDeliveryPrice: Function,
        getAddressList: Function,
        recipeData: Object,
        dialogForm: Object,
        hospPatientInfo: Object,
        getProcessingPrice: Function,
        drugPrice: [Number, String],
        computeTotalPrice: Function,
        getOrderList: Function,
        addressList: Array
    },
    created() {
        this.$getDoctorOptions(); // 获取所有医生列表
        this.getIngredientsList(); // 获取所有辅料列表
    },
    methods: {
        /**
         *  获取联合订单编号
         */
        getUniOrderNumber() {
            return new Promise((resolve, reject) => {
                getUniOrderNumber({ deptId: this.$session.get('deptId') }).then(res => {
                    if (res.code == 200) {
                        this.orderNumber = res.data.orderNumber
                        resolve(res.data.orderNumber)
                    }
                })
            })
        },
        /**
         * 获取订单编号
         */
        getOrderNumber() {
           return new Promise((resolve, reject) => {
                let params = {
                    deptId: this.$session.get('deptId'),
                    uniOrderNumber: this.orderNumber,
                    type: '1'
                }
                getOrderNumber(params).then(res => {
                    if (res.code == '200') {
                        resolve(res.data.orderNumber)
                    }
                })
            })
        },
        // 设置医生信息
        setDoctorName(val) {
            this.doctorOptions.forEach(item => {
                if (item.value == val) {
                    this.recipeData.doctorName = item.label;
                    this.recipeData.doctorCode = item.doctorCode
                    if (item.label != '外来医生') this.recipeData.salesPerson = item.label;
                    else this.recipeData.salesPerson = this.$session.get('user').nickName;
                }
            })
        },
        // 不展示过滤袋
        tableRowClassName({ row }) {
            if (row.drugName.indexOf('过滤袋') != -1) return 'hidden';
            else return '';
        },
        // 修改拍单状态
        async editAuction(obj, status) {
            let { code } = await auctionEdit({ status: status, auctionId: obj.auctionId });
            if (code == 200) {
                this.$message.success("切换拍单状态成功!");
                this.loading = true;
                if (status != '0') this.examine(obj.auctionId, 'view');
                this.getOrderList();
            }
        },
        // 保存划价新增
        pricingAddSave(obj, delivery, recipe) {
            let falg = false
            if (recipe.recipeDrugItem && recipe.recipeDrugItem.length > 0) {
                recipe.recipeDrugItem.forEach(item => {
                    if (item.number == 0 || item.number == null || item.number == '') falg = true;
                    if (this.$bigNumber(item.number, '*', obj.doseNumber) > item.inventory) falg = true;
                })
            }
            if (falg) return this.$message.error('库存不足或数量为0，请重新选择！');
            if (recipe.doctorId == null) this.$message.error('医生不能为空，请选择后再试！');
            else if (recipe.drugAmount == 0) this.$message.error('药材不能为空，请添加后再试！');
            else {
                let params = this.handlePricing(obj, delivery, recipe);
                pricingJudge(params).then(res => {
                    if (res.code == 200) this.drugPayAdd(params, this.dialogForm);
                    else {
                        let msg = '';
                        if (res.data.effectsDrugs) {
                            res.data.effectsDrugs.forEach(item => {
                                msg += `${item.drugNameOne} 与 ${item.drugNameTwo} 相${type == 0 ? '反' : '畏'}，`
                            });
                        }
                        if (res.data.excessDrugs) {
                            res.data.excessDrugs.forEach(item => {
                                msg += `${item.drugName}超量，最大数量为${item.number}，`
                            });
                        }
                        this.$confirm(msg + "是否继续保存划价单？").then(_ => { this.drugPayAdd(params, this.dialogForm) }).catch(_ => { });
                    }
                });
            }
        },
        // 划价新增请求
        async drugPayAdd(params, obj) {
            await this.getUniOrderNumber();
            params.orderNumber = await this.getOrderNumber();
            let { doctorName, doctorCode, doctorId, imgAddr, userCode, discountType, realPay, discount, totalPrice, drugPrice, patientId, orderDelivery, recipeDrugIngredient, deptRemark, patientRemark, deliveryPrice, isInvoice, isDelivery } = params
            let doctorInfo = { doctorName, doctorCode, doctorId, doctorImgAddr: imgAddr, userCode, salesPerson: doctorName }
            let newPayFrom = {
                amount: 0,
                bargainType: discountType,
                casreceiptsh: realPay,
                changeMoney: 0,
                discount,
                discountPrice: this.$bigNumber(totalPrice, '-', realPay),
                drugAmount: 0,
                drugPrice: drugPrice,
                receivable: 0,
                totalPrice: realPay,
                type: '2'
            }
            let editForm = {
                registerPrice: '',
                type: '1',
            }
            let josn = {
                diagnosis: '',
                diagnosisList: [{ diagnoseCode: '', diagnoseName: '' }],
                doctorInfo,
                orderRecipeCombo: [],
                orderRecipePhysio: [],
                orderRecipeDrug: [params],
                newPayFrom,
                patientInfo: this.hospPatientInfo,
                editForm,
                orderDelivery: { ...orderDelivery, deliveryPrice,},
                ingredientsList: recipeDrugIngredient,
                payment:{
                    patientRemark,
                    deptRemark,
                    isDelivery,
                    isInvoice
                }
            }
            let paramsObj = {
                deptId: this.$session.get('deptId'),
                doctorId,
                doctorName,
                json: JSON.stringify(josn),
                orderNumber: this.orderNumber,
                patientId
            }
            let { code, data } = await editOrderStaging(paramsObj);
            if (code == 200) {
                this.$message.success('新增划价单成功！');
                obj.status = '1';
                this.auctionEditSave(obj, this.dialogForm.orderDelivery, data);
            }
        },
        // async drugPayAdd(params, obj) {
        //     let { code, data } = await drugPaymentAdd3({ orderPaymentRecipeDrug: params });
        //     if (code == 200) {
        //         this.$message.success('新增划价单成功！');
        //         obj.status = '1';
        //         this.auctionEditSave(obj, this.dialogForm.orderDelivery, data);
        //     }
        // },
        // 修改拍单
        async auctionEditSave(obj, delivery, data) {
            let params = this.handleAuction(obj, delivery);
            let { code } = await auctionEdit(params, 0);
            if (code == 200) {
                this.loading = true;
                this.$router.push(`/pricing/pricingdetails?page=pricing&flag=true&orderId=${data}&patientId=${obj.patientId}&doctorId=${obj.doctorId}`);
            }
            this.$emit('dialogFormBack', false);
        },
        // 划价单对象处理
        handlePricing(obj, delivery, recipe) {
            for (let key in obj) {
                // if (key.indexOf('rice') != '-1') obj[key] = Math.round(obj[key] * 100) / 100;
                if (key.indexOf('rice') != '-1') obj[key] = this.$toFixed(obj[key]);
            }
            // 拼接对象
            let params = obj;
            params.orderDelivery = delivery;
            params.discountDrugPrice = this.$bigNumber(params.drugPrice, '*', params.discount, 2);
            params.recipeDrugItem = recipe.recipeDrugItem;
            params.drugAmount = recipe.drugAmount;
            params.doctorId = recipe.doctorId;
            params.doctorName = recipe.doctorName;
            params.doctorCode = recipe.doctorCode;
            params.patientPhone = this.hospPatientInfo.phone;
            params.salesPerson = recipe.salesPerson;
            params.weight = recipe.weight;
            params.userCode = 609998;
            let doseObj = {
                dose: '1日1付',
                frequency: '1日3次',
                takingDosage: params.takingDosage,
                drugMethod: '煎服',
                remark: '饭后服用'
            }
            params = { ...params, ...doseObj }
            // 判断处方类型
            if (params.types == '图片处方') params.recipeType = '1';
            else params.recipeType = '0';
            params.type = '1';
            // 计算成本价
            params.costPrice = 0;
            recipe.recipeDrugItem.forEach(item => {
                params.costPrice = this.$bigNumber(params.costPrice, '+', this.$bigNumber(this.$bigNumber(item.cost, '*', item.number), '*', params.doseNumber));
            });
            // params.costPrice = Math.round(params.costPrice * 100) / 100;
            params.costPrice = this.$toFixed(params.costPrice);
            // 处理处方类型
            let doseType = [];
            params.recipeDrugItem.forEach(item => {
                if (item.type == '中药饮片') doseType.push('0');
                else if (item.type == '中药颗粒') doseType.push('1');
            });
            let typeList = [...new Set(doseType)];
            if (typeList.length === 1) params.doseType = typeList[0];
            else params.doseType = '2';
            return params;
        },
        // 拍单对象处理
        handleAuction(obj, delivery) {
            let {
                cityName,
                cityId,
                companyName,
                detailedAddress,
                phone,
                provinceName,
                provinceId,
                regionName,
                regionId,
                consigneeName,
                scopeName,
                scopeId
            } = delivery;
            // 处理配送相关数据
            let orderDelivery = {
                cityName,
                cityId,
                deliveryWay: companyName,
                detailedAddress,
                phone,
                provinceName,
                provinceId,
                regionName,
                regionId,
                consigneeName,
                scopeName,
                scopeId
            }
            for (let key in orderDelivery) {
                for (let keys in obj) {
                    if (key == keys) obj[keys] = orderDelivery[key];
                }
            }
            // 拍单相关数据
            obj.status = 1;
            obj.paymentType = 0;
            obj.remark = obj.patientRemark;
            return obj;
        },
        // 拍单图片识别失败
        async failAuction(auctionId) {
            if (this.failForm.reason == null) this.$message.error('识图失败理由不能为空！');
            else {
                let { code } = await auctionFail({ reason: this.failForm.reason, auctionId });
                if (code == 200) {
                    this.$message.success('识图失败请求成功，已给患者推送模板消息告知！');
                    this.$emit('dialogFormBack', false);
                    this.failForm.reason = null;
                }
            }
        },

        /* 药材模块 开始 */
        // 请求药品列表
        async getDrugsList(query) {
            this.drugOptions = [];
            if (query != '' && query != null) {
                let { rows, code } = await drugList({ searchValue: query });
                if (code == 200) {
                    rows.forEach((item, i) => {
                        item.disabled = false;
                        this.recipeData.recipeDrugItem.forEach(items => {
                            if (item.drugId == items.drugId) item.disabled = true;
                        });
                        if (item.drugName.indexOf('过滤袋') == -1) this.drugOptions.push(item);
                    });
                    this.selectLoading = false
                } else {
                    this.selectLoading = false
                }
            }
        },
        // 保存药品
        setDrug(obj) {
            this.drugOptions.forEach(item => {
                if (item.drugId == this.drugId) {
                    let { drugId, type, drugName, price, unit, inventory, manufacturer, cost, id, dictDrugCode } = item;
                    if (inventory == 0) {
                        return this.$message.error('库存不足，请重新选择!');
                    }
                    obj.recipeDrugItem.push({
                        drugId,
                        type,
                        drugName,
                        unit,
                        dictDrugCode,
                        inventory,
                        manufacturer,
                        totalPrice: this.$bigNumber(price, '*', (inventory >= 1 ? 1 : 0.01), 2),
                        cost,
                        artNo: id,
                        costTotalPrice: cost,
                        price,
                        number: inventory > 1 ? 1 : 0.01,
                    });
                    obj.weight++;
                    this.dialogForm.drugPrice = this.$bigNumber(this.dialogForm.drugPrice, '+', this.$bigNumber(price, '*', this.dialogForm.doseNumber));
                    this.dialogForm.costPrice = this.$bigNumber(this.dialogForm.costPrice, '+', this.$bigNumber(cost, '*', this.dialogForm.doseNumber));
                    this.getProcessingPrice(this.dialogForm);
                    // this.getDeliveryPrice(this.dialogForm.orderDelivery);
                }
            });
            // this.dialogForm.drugPrice = Math.round(this.dialogForm.drugPrice * 100) / 100;
            this.dialogForm.drugPrice = this.$toFixed(this.dialogForm.drugPrice);
            // this.dialogForm.costPrice = Math.round(this.dialogForm.costPrice * 100) / 100;
            this.dialogForm.costPrice = this.$toFixed(this.dialogForm.costPrice);
            obj.drugAmount += 1;
            this.drugId = null;
            this.numberInputOnfucos(obj);
            this.computeTotalWeight(this.dialogForm, obj)
            this.drugOptions = [];
        },
        // 数量输入框聚焦
        numberInputOnfucos(obj) {
            let timer = setTimeout(() => {
                let inputWrap = document.getElementsByClassName('drugNumber')[obj.drugAmount - 1];
                let numberInput = inputWrap.getElementsByTagName('input')[0];
                numberInput.select();
                clearTimeout(timer);
            }, 300);
        },
        // 药品选择框聚焦
        drugInputOnFocus() {
            let drugWrap = document.getElementsByClassName('drugSelect')[0];
            let drugInput = drugWrap.getElementsByTagName('input')[0];
            drugInput.focus();
        },
        // 药品数量输入框上下切换
        numberInputMove(row, flag) {
            let obj = this.recipeData;
            let i, len = obj.recipeDrugItem.length;
            obj.recipeDrugItem.forEach((item, index) => {
                if (item.artNo == row.artNo) i = index;
            });
            if (flag == 1) {
                if (i < len - 1 && len > 1) {
                    let inputWrap = document.getElementsByClassName('drugNumber')[i + 1];
                    let numberInput = inputWrap.getElementsByTagName('input')[0];
                    let timer = setTimeout(() => {
                        numberInput.select();
                        clearTimeout(timer);
                    }, 1);
                }
            } else {
                if (i > 0) {
                    let inputWrap = document.getElementsByClassName('drugNumber')[i - 1];
                    let numberInput = inputWrap.getElementsByTagName('input')[0];
                    let timer = setTimeout(() => {
                        numberInput.select();
                        clearTimeout(timer);
                    }, 1);
                }
            }
        },
        // 删除药品
        delDrug(obj, drugId) {
            obj.recipeDrugItem.forEach((item, i) => {
                if (drugId == item.drugId) {
                    obj.recipeDrugItem.splice(i, 1);
                    // obj.weight -= item.number;
                    obj.weight = this.$bigNumber(obj.weight, '-', item.number);
                    this.dialogForm.drugPrice = this.$bigNumber(this.dialogForm.drugPrice, '-', this.$bigNumber(item.price, '*', this.dialogForm.doseNumber));
                    this.dialogForm.drugPrice = this.$toFixed(this.dialogForm.drugPrice);
                    // this.dialogForm.costPrice -= item.cost * this.dialogForm.doseNumber;
                    this.dialogForm.costPrice = this.$bigNumber(this.dialogForm.costPrice, '-', this.$bigNumber(item.cost, '*', this.dialogForm.doseNumber));
                    this.getProcessingPrice(this.dialogForm);
                    this.getDeliveryPrice(this.dialogForm.orderDelivery);
                }
            });
            this.dialogForm.costPrice = this.$toFixed(this.dialogForm.costPrice);
            obj.drugAmount -= 1;
        },
        // 计算药材费小计
        computeDrugSubPrice(item, obj) {
            // this.inventoryMax(item.number, item.inventory);
            item.totalPrice = this.$bigNumber(item.price, '*', item.number, 2);
            item.costTotalPrice = this.$bigNumber(item.cost, '*', item.number);
            this.computeDrugPrice(obj, this.dialogForm); // 计算药材费总价
            this.computeTotalWeight(this.dialogForm, obj); // 计算处方总重量
            this.getProcessingPrice(this.dialogForm);
            this.getDeliveryPrice(this.dialogForm.orderDelivery);
        },
        // 计算药材总价
        computeDrugPrice(obj, form) {
            form.drugPrice = 0, form.costPrice = 0;
            obj.recipeDrugItem.forEach(item => {
                let tempTotal = this.$bigNumber(item.price, '*', item.number)
                form.drugPrice = this.$bigNumber(form.drugPrice, '+', this.$bigNumber(tempTotal, '*', form.doseNumber), 2);
                form.costPrice = this.$bigNumber(form.costPrice, '+', this.$bigNumber(tempTotal, '*', form.doseNumber));
            });
            form.costPrice = this.$toFixed(form.costPrice);
            form.drugPrice = this.$toFixed(form.drugPrice);
            this.computeTotalPrice(form); // 计算总价
        },
        /* 药材模块 结束 */

        /* 辅料模块 开始 */
        // 请求所有辅料列表
        async getIngredientsList() {
            let { rows, code } = await ingredientsList();
            if (code == 200) this.ingredientsList = rows;
        },
        // 保存辅料
        setIngredient(obj) {
            this.ingredientsList.forEach(item => {
                if (item.ingredientsId == this.ingredientsId) {
                    obj.recipeDrugIngredient.push({
                        ingredientsId: item.ingredientsId,
                        type: item.type,
                        ingredientsName: item.ingredientsName,
                        price: item.price,
                        number: item.minNumber,
                        unit: item.unit,
                        totalPrice: this.$bigNumber(item.price, '*', item.minNumber),
                        minNumber: item.minNumber
                    });
                    item.disabled = true; {
                        this.recipeData.weight = this.$bigNumber(this.recipeData.weight, '+', item.minNumber);
                        this.getProcessingPrice(obj);
                        this.getDeliveryPrice(obj);
                    }
                    obj.ingredientsPrice = this.$bigNumber(obj.ingredientsPrice, '+', this.$bigNumber(item.price, '*', item.minNumber));
                }
            });
        },
        // 删除辅料
        delIngredient(obj, ingredientsId) {
            // 删除辅料/减重量/减价格
            obj.recipeDrugIngredient.forEach((item, i) => {
                if (ingredientsId == item.ingredientsId) {
                    this.recipeData.weight = this.$bigNumber(this.recipeData.weight, '-', item.number);
                    this.getProcessingPrice(obj);
                    this.getDeliveryPrice(obj);
                    obj.ingredientsPrice = this.$bigNumber(obj.ingredientsPrice, '-', item.totalPrice);
                    obj.recipeDrugIngredient.splice(i, 1);
                    this.computeTotalPrice(obj); // 计算总价
                }
            });
            // 恢复辅料可选
            this.ingredientsList.forEach(item => {
                if (item.ingredientsId == ingredientsId) item.disabled = false;
            });
            this.ingredientsId = null;
        },
        // 计算辅料费小计
        computeIngredientSubPrice(item, obj) {
            item.totalPrice = this.$bigNumber(item.price, '*', item.number);
            this.computeIngredientPrice(obj); // 计算辅料费总价
            this.computeTotalWeight(obj, this.recipeData); // 计算处方总重量
            {
                this.getProcessingPrice(obj);
                this.getDeliveryPrice(obj);
            }
        },
        // 计算辅料总价
        computeIngredientPrice(obj) {
            obj.ingredientsPrice = 0;
            obj.recipeDrugIngredient.forEach(item => { obj.ingredientsPrice = this.$bigNumber(obj.ingredientsPrice, '+', Number(item.totalPrice)) });
            this.computeTotalPrice(obj); // 计算总价
        },
        /* 辅料模块 结束 */

        // 计算处方重量
        computeTotalWeight(obj, recipe) {
            recipe.weight = 0;
            obj.recipeDrugIngredient.forEach(item => { recipe.weight = this.$bigNumber(recipe.weight, '+', item.number) }); // 辅料重量
            recipe.recipeDrugItem.forEach(item => { recipe.weight = this.$bigNumber(recipe.weight, '+', this.$bigNumber(item.number, '*', obj.doseNumber)) }); // 药材重量
            recipe.weight = this.$toFixed(recipe.weight);
        },
        // 过滤袋个数改变
        async filterNumberChange(obj) {
            let { code, rows } = await drugList({ drugName: '过滤袋' });
            if (code == 200) {
                obj.filterPrice = this.$bigNumber(obj.drugNumber, '*', rows[0].price);
                obj.filterDrugArtNo = rows[0].id
                this.computeTotalPrice(obj);
            }
        },
        // 处方付数改变
        doseNumberChange(obj) {
            // this.recipeData.recipeDrugItem.forEach(item => {
            //     item.inventory = Math.ceil(this.$bigNumber(this.$bigNumber(item.inventory, '*', this.doseNumber), '/', obj.doseNumber));
            // })
            this.doseNumber = obj.doseNumber;
            this.getDeliveryPrice(obj);
            this.getProcessingPrice(obj);
            this.computeDrugPrice(this.recipeData, obj);
            this.computeTotalWeight(obj, this.recipeData)
        },

        /* 加工模块 开始 */
        // 切换是否加工
        changeIsProcessing(val, obj) {
            if (val == 0) {
                obj.processingWay = null;
                obj.processingPrice = 0;
                obj.bagNumber = 0;
                obj.bagNumberSum = 0;
                this.$forceUpdate();
                this.getProcessingPrice(obj);
            } else {
                obj.processingWay = '熬药';
                obj.bagNumber = 3;
                obj.bagNumberSum = this.$bigNumber(3, '*', obj.doseNumber);
                this.getProcessingPrice(obj);
            }
        },
        // 切换加工方式
        changeProcessing(val, obj) {
            if (val != '熬药') {
                obj.bagNumber = 0;
                obj.bagNumberSum = 0;
                this.getProcessingPrice(obj);
            } else {
                obj.bagNumber = 3;
                obj.bagNumberSum = this.$bigNumber(3, '*', obj.doseNumber);
                this.getProcessingPrice(obj);
            }
        },
        /* 加工模块 结束 */

        /* 配送模块 开始 */
        // 切换配送方式
        deliveryChange(val) {
            let obj = this.dialogForm;
            if (this.dialogForm.orderDelivery.detailedAddress != null) {
                let orderDelivery = {
                    cityName: obj.cityName,
                    cityId: obj.cityId,
                    companyName: val,
                    consigneeName: obj.consigneeName,
                    detailedAddress: obj.detailedAddress,
                    phone: obj.phone,
                    provinceName: obj.provinceName,
                    provinceId: obj.provinceId,
                    regionName: obj.regionName,
                    regionId: obj.regionId,
                    price: null,
                    scopeName: obj.scopeName,
                    scopeId: obj.scopeId
                }
                this.$emit('orderDeliveryBack', orderDelivery);
                this.getDeliveryPrice(orderDelivery);
            } else this.$message.error('地址信息不全，请完善后获取配送费!');
        },
        // 切换是否配送
        changeDelivery(val) {
            if (val == '0') {
                obj.deliveryPrice = 0;
                let orderDelivery = {
                    cityName: null,
                    cityId: null,
                    companyName: val,
                    consigneeName: obj.consigneeName,
                    detailedAddress: null,
                    phone: obj.phone,
                    provinceName: null,
                    provinceId: null,
                    regionName: null,
                    regionId: null,
                    scopeName: null,
                    scopeId: null
                }
                this.$emit('orderDeliveryBack', orderDelivery);
                this.computeTotalPrice(obj);
            } else this.$message.error('请选择配送方式和收件地址获取配送费！')
        },
        /* 配送模块 结束 */

        /* 其他模块 */
        // 失焦判断药品数量是否超过最大值
        inventoryMax(num, max) {
            if (num >= max) this.$message(`当前药品已达库存${max}!`);
        },
        // 弹框关闭前提示
        close(done) {
            this.$confirm('确认关闭？').then(_ => { this.$emit('dialogFormBack', false) }).catch(_ => { });
        },
        // 关闭弹框时将值返回给父组件
        visibleBack() {
            this.$emit('dialogFormBack', false);
        },
        formatNum(e, scope) {
            if (e > scope.inventory) return this.$message.error(`当前药品库存不足，请修改数量或重新选择!`);
            let temp = e.toString();
            temp = temp.replace(/。/g, ".");
            temp = temp.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
            temp = temp.replace(/^\./g, ""); //验证第一个字符是数字
            temp = temp.replace(/\.{2,}/g, ""); //只保留第一个, 清除多余的
            temp = temp.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
            temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
            scope.number = temp;

        },
    }
}